import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './users.entity';

@Injectable()
export class ProfileService extends AbstractService {
  getProfile(id: number, subscriptionId?: number): Observable<ApiResponse.Profile> {
    return this.get<ApiResponse.Profile>(`/users/${ id }`, { subscriptionId });
  }
  
  resetNeedPlayGames(): Observable<void> {
    return this.post<void>('/users/reset-need-play-games', {}, { throwError: true });
  }
}